import {deepClone} from '../util/helpers'

export default {
  data: function () {
    return {
      itemKeys: new WeakMap(),
      currentItemKey: 0
    }
  },

  computed: {
    label () {
      return this.types || this.type ? this.type + 's' : false
    }
  },

  props: {
    type: String,
    types: String,
    value: Array,
    itemDefault: Object,
    disabled: Boolean,
    disableAdd: Boolean,
    jsonPath: String,
    addAction: Function,
    deleteAction: Function,
    promptIconColor: {
      type: String,
      default: 'error'
    },
    disableDelete: Boolean,
    deleteIcon: {
      type: String,
      default: 'mdi-delete'
    },
    deleteConfirmText: {
      type: [String, Function],
      default: 'Delete'
    },
    deletePromptMessage: [String, Function],
    itemName: {
      type: [Function, String],
      default (item, rowIndex) {
        item = item || {}
        return item.name ? this.type + ' "' + item.name + '"' : false || 'this ' + this.type
      }
    },
    getPathErrors: {
      type: [Function],
      default (path) {
        return []
      }
    },
    clearPathErrors: {
      type: [Function],
      default (path) {
      }
    },
    movePathErrors: {
      type: [Function],
      default (path) {
      }
    },
    deletePrompt: {
      type: Function,
      default (rowIndex, item, deleteAction) {
        setTimeout(
          () => {
            this.$vPrompt({
              title: this.getDeletePromptTitle(item),
              titleIcon: this.deleteIcon,
              titleIconColor: this.promptIconColor,
              text: this.getDeletePromptMessage(item),
              confirmText: 'Yes',
              confirmAction: () => {
                deleteAction(rowIndex)
              },
              cancelText: 'No',
              disableConfirm: this.disabled,
              cancelDialog: this.disabled,
              cancelAction: true
            })
          }, 0
        )
      }
    }
  },

  methods: {
    buildJsonPath (index, name) {
      var path = this.jsonPath
      if (Number.isInteger(index)) {
        path += '[' + index + ']'
      } else if (typeof index === 'string') {
        path += '.' + index
      }
      if (typeof name === 'string') {
        path += '.' + name
      }
      return path
    },
    getDeleteConfirmText (item) {
      if (typeof this.deleteConfirmText === 'function') {
        return this.deleteConfirmText(item) || 'Delete'
      } else {
        return this.deleteConfirmText || 'Delete'
      }
    },
    getDeletePromptTitle (item) {
      return this.deletePromptTitle || this.getDeleteConfirmText(item) + ' ' + this.type
    },
    getDeletePromptMessage (item) {
      if (typeof this.deletePromptMessage === 'function') {
        return this.deletePromptMessage(item) || this.getDefaultConfirmPromptMessage(item)
      } else {
        return this.deletePromptMessage || this.getDefaultConfirmPromptMessage(item)
      }
    },
    getDefaultConfirmPromptMessage (item) {
      return 'Are you sure you want to ' + this.getDeleteConfirmText(item).toLowerCase() + ' ' + this.buildItemName(item) + '?'
    },
    itemKey (item) {
      // Get UID for object
      if (!this.itemKeys.has(item)) {
        this.itemKeys.set(item, ++this.currentItemKey)
      }
      return this.itemKeys.get(item)
    },
    doAdd () {
      var newItem = deepClone(this.itemDefault)
      if (this.addAction) {
        this.addAction(newItem, this.addItem)
      } else {
        this.addItem(newItem)
      }
    },
    addItem (newItem) {
      this.value.push(newItem)
      this.$emit('add', newItem)
    },
    doDelete (rowIndex) {
      if (this.deleteAction) {
        this.deleteAction(rowIndex, this.deleteItem)
      } else {
        this.deleteItem(rowIndex)
      }
    },
    deleteItem (rowIndex) {
      this.value.splice(rowIndex, 1)
      this.movePathErrors(this.jsonPath, rowIndex)
      this.$emit('delete')
    },
    buildItemName (item) {
      if (typeof this.itemName === 'function') {
        return this.itemName(item)
      }
      return item[this.itemName] || 'this ' + this.type
    },
    sendError (message) {
      this.$emit('error', message)
    },
    buildRefName (field, row) {
      return field + '__' + row
    },
    convertInt (value) {
      if (value === '') {
        return null
      } else {
        var temp = parseInt(value, 10)
        return isNaN(temp) ? value : temp
      }
    },
    convertFloat (value) {
      if (value === '') {
        return null
      } else {
        var temp = parseFloat(value)
        return isNaN(temp) ? value : temp
      }
    },
    setCellValue (item, field, editor, row, value, forceType) {
      var _this = this
      editor = editor || {}
      if (typeof value === 'string') {
        value = value.trim()
      }
      if (editor.invert) {
        value = !value
      }
      switch (forceType || editor.slotType || editor.mode) {
      case 'int':
      case 'integer':
        value = _this.convertInt(value)
        break
      case 'number':
      case 'currency':
      case 'float':
        value = _this.convertFloat(value)
        break
      }
      if (item[field] !== value) {
        _this.$set(item, field, value)
        _this.clearFieldErrorLookup(row, field)
      }
    },
    clearFieldErrorLookup (row, field) {
      this.clearPathErrors(this.jsonPath, row, field)
    },
    getInputs () {
      const results = []

      const search = (children, depth = 0) => {
        for (const child of children) {
          if (child.errorBucket !== undefined) {
            results.push(child)
          } else {
            search(child.$children, depth + 1)
          }
        }
        if (depth === 0) return results
      }

      return search(this.$children)
    }
  }
}
